import * as React from "react"
import {
    Heading,
    Stack,
    Text,
} from '@chakra-ui/react';

export default function LandingPageCallUs({callUsText}) {

    return (
        <Stack direction={'column'} alignItems='center' spacing={'30px'}>
            <Heading>{callUsText.heading}</Heading>
            {callUsText.textPara.map((item) => {
                return (
                    <Text className="subTitle" fontSize={{ base: 'lg', lg: 'xl' }}>
                        {item}
                    </Text>
                );
            })}
        </Stack>
    );
}